import axios from 'axios'
import {uriConstants} from "../constants";

export const questionService = {
  regis,
  edit,
}

async function regis(params) {
  const formData = new FormData()

  formData.append('questCd', params.questCd)
  formData.append('regName', params.regName)
  formData.append('idEmail', params.idEmail)
  formData.append('mobileNo', params.mobileNo)
  formData.append('encPasswd', params.encPasswd)
  formData.append('questTitle', params.questTitle)
  formData.append('question', params.question)

  let files = params.files?.filter(function (item) {
    return item !== null && item !== undefined;
  });

  files.forEach(file => {
    formData.append('files', file, file.name);
  })

  const user = JSON.parse(localStorage.getItem('user'));
  return await axios.post(
      uriConstants.API_URI + uriConstants.QUESTION,
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + user.payload.accessToken
        }
      })
}

async function edit(params) {
  const formData = new FormData()

  formData.append('questCd', params.questCd)
  formData.append('regName', params.regName)
  formData.append('idEmail', params.idEmail)
  formData.append('mobileNo', params.mobileNo)
  formData.append('encPasswd', params.encPasswd)
  formData.append('questTitle', params.questTitle)
  formData.append('question', params.question)
  formData.append('delFileIds', params.delFileIds)
  formData.append('token', params.token)

  let files = params.files?.filter(function (item) {
    return item !== null && item !== undefined && item?.isOrigin !== true;
  });

  files.forEach(file => {
    formData.append('files', file, file.name);
  })

  const user = JSON.parse(localStorage.getItem('user'));
  return await axios.put(
      uriConstants.API_URI + uriConstants.QUESTION + '/' + params.seq,
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + user.payload.accessToken
        }
  })
}